<div class="stats-table-container call-center-stats-component">
  <mat-card class="stats-card">
    <mat-card-content>
      <h2 class="table-header">
        @if (isSummaryTable && weekData) {
          <div class="summary-header">
            <div>Hét összefoglalója</div>
            <div class="week-info">
              <span>Kiválasztott hét: {{ weekData.weekNumber }}. hét</span>
              <span>Időszak: {{ weekData.startDate.toLocaleDateString('hu-HU') }} - {{ weekData.endDate.toLocaleDateString('hu-HU') }}</span>
            </div>
          </div>
        } @else if (isSummaryTable) {
          CC - Összesen
        } @else {
          CC - {{ staffMember?.username || 'Ismeretlen' }}
          @if (isLoading) {
            <span class="loading-text">(Betöltés...)</span>
          }
        }
      </h2>
      
      <div class="table-wrapper" [class.menu-open]="isMenuOpen">
        <table mat-table [dataSource]="statsData" [trackBy]="trackByIndex" class="stats-table">
          
          <!-- Kategória oszlop -->
          <ng-container matColumnDef="category">
            <th mat-header-cell *matHeaderCellDef class="category-header"
                (mouseenter)="onColumnHover('category')"
                (mouseleave)="onColumnLeave()"></th>
            <td mat-cell *matCellDef="let row" 
                [class]="getRowClass(row)"
                [style.background-color]="row.backgroundColor"
                (mouseenter)="onColumnHover('category')"
                (mouseleave)="onColumnLeave()">
              <div class="cell-content">
                <span>
                  {{ row.category }}
                </span>
              </div>
            </td>
          </ng-container>

          <!-- Hétfő oszlop -->
          <ng-container matColumnDef="monday">
            <th mat-header-cell *matHeaderCellDef class="day-header"
                (mouseenter)="onColumnHover('monday')"
                (mouseleave)="onColumnLeave()">Hétfő</th>
            <td mat-cell *matCellDef="let row; let rowIndex = index" 
                [class]="getCellClassWithColumnNote(row.monday, 2, 'monday')"
                [ngStyle]="getCellStyle(row, 'monday')"
                (mouseenter)="onColumnHover('monday')"
                (mouseleave)="onColumnLeave()">
              <div class="cell-content">
                @if (!isLastRow(row)) {
                  <span>{{ row.monday }}</span>
                }
                @if (!isSummaryTable && shouldShowNoteIcon(row, 'monday') && canEditSummaryNotes()) {
                  <mat-icon class="note-icon"
                            [matMenuTriggerFor]="mondayNoteMenu.menu"
                            (click)="setSelectedColumn('monday', mondayMenuTrigger)"
                            (menuOpened)="mondayNoteMenu.onMenuOpened()"
                            (menuClosed)="onMenuAction()"
                            #mondayMenuTrigger="matMenuTrigger">
                    edit_note
                  </mat-icon>
                }
                @if (!isSummaryTable && shouldShowNoteChip(row, 'monday')) {
                  <mat-chip [class]="'note-chip ' + getNoteChipClass('monday') + (canEditSummaryNotes() ? ' clickable-chip' : '')"
                            [matMenuTriggerFor]="canEditSummaryNotes() ? mondayNoteMenu.menu : null"
                            (click)="canEditSummaryNotes() ? setSelectedColumn('monday', mondayChipTrigger) : null"
                            (menuOpened)="mondayNoteMenu.onMenuOpened()"
                            (menuClosed)="onMenuAction()"
                            #mondayChipTrigger="matMenuTrigger">
                    <span>{{ getNoteText('monday') }}</span>
                  </mat-chip>
                }
                @if (isSummaryTable && shouldShowSummaryNoteIcon(row, 'monday')) {
                  <mat-icon class="note-icon"
                            [matMenuTriggerFor]="mondaySummaryNoteMenu.menu"
                            (click)="setSelectedColumn('monday', mondaySummaryMenuTrigger)"
                            (menuOpened)="mondaySummaryNoteMenu.onMenuOpened()"
                            (menuClosed)="onMenuAction()"
                            #mondaySummaryMenuTrigger="matMenuTrigger">
                    edit_note
                  </mat-icon>
                }
                @if (isSummaryTable && shouldShowSummaryNoteChip(row, 'monday')) {
                  <mat-chip [class]="'note-chip ' + getSummaryNoteChipClass('monday') + (canEditSummaryNotes() ? ' clickable-chip' : '')"
                            [matMenuTriggerFor]="canEditSummaryNotes() ? mondaySummaryNoteMenu.menu : null"
                            (click)="canEditSummaryNotes() ? setSelectedColumn('monday', mondaySummaryChipTrigger) : null"
                            (menuOpened)="mondaySummaryNoteMenu.onMenuOpened()"
                            (menuClosed)="onMenuAction()"
                            #mondaySummaryChipTrigger="matMenuTrigger">
                    <span>{{ getSummaryNoteText('monday') }}</span>
                  </mat-chip>
                }
              </div>
            </td>
          </ng-container>

          <!-- Kedd oszlop -->
          <ng-container matColumnDef="tuesday">
            <th mat-header-cell *matHeaderCellDef class="day-header"
                (mouseenter)="onColumnHover('tuesday')"
                (mouseleave)="onColumnLeave()">Kedd</th>
            <td mat-cell *matCellDef="let row; let rowIndex = index" 
                [class]="getCellClassWithColumnNote(row.tuesday, 3, 'tuesday')"
                [ngStyle]="getCellStyle(row, 'tuesday')"
                (mouseenter)="onColumnHover('tuesday')"
                (mouseleave)="onColumnLeave()">
              <div class="cell-content">
                @if (!isLastRow(row)) {
                  <span>{{ row.tuesday }}</span>
                }
                @if (!isSummaryTable && shouldShowNoteIcon(row, 'tuesday') && canEditSummaryNotes()) {
                  <mat-icon class="note-icon"
                            [matMenuTriggerFor]="tuesdayNoteMenu.menu"
                            (click)="setSelectedColumn('tuesday', tuesdayMenuTrigger)"
                            (menuOpened)="tuesdayNoteMenu.onMenuOpened()"
                            (menuClosed)="onMenuAction()"
                            #tuesdayMenuTrigger="matMenuTrigger">
                    edit_note
                  </mat-icon>
                }
                @if (!isSummaryTable && shouldShowNoteChip(row, 'tuesday')) {
                  <mat-chip [class]="'note-chip ' + getNoteChipClass('tuesday') + (canEditSummaryNotes() ? ' clickable-chip' : '')"
                            [matMenuTriggerFor]="canEditSummaryNotes() ? tuesdayNoteMenu.menu : null"
                            (click)="canEditSummaryNotes() ? setSelectedColumn('tuesday', tuesdayChipTrigger) : null"
                            (menuOpened)="tuesdayNoteMenu.onMenuOpened()"
                            (menuClosed)="onMenuAction()"
                            #tuesdayChipTrigger="matMenuTrigger">
                    <span>{{ getNoteText('tuesday') }}</span>
                  </mat-chip>
                }
                @if (isSummaryTable && shouldShowSummaryNoteIcon(row, 'tuesday')) {
                  <mat-icon class="note-icon"
                            [matMenuTriggerFor]="tuesdaySummaryNoteMenu.menu"
                            (click)="setSelectedColumn('tuesday', tuesdaySummaryMenuTrigger)"
                            (menuOpened)="tuesdaySummaryNoteMenu.onMenuOpened()"
                            (menuClosed)="onMenuAction()"
                            #tuesdaySummaryMenuTrigger="matMenuTrigger">
                    edit_note
                  </mat-icon>
                }
                @if (isSummaryTable && shouldShowSummaryNoteChip(row, 'tuesday')) {
                  <mat-chip [class]="'note-chip ' + getSummaryNoteChipClass('tuesday') + (canEditSummaryNotes() ? ' clickable-chip' : '')"
                            [matMenuTriggerFor]="canEditSummaryNotes() ? tuesdaySummaryNoteMenu.menu : null"
                            (click)="canEditSummaryNotes() ? setSelectedColumn('tuesday', tuesdaySummaryChipTrigger) : null"
                            (menuOpened)="tuesdaySummaryNoteMenu.onMenuOpened()"
                            (menuClosed)="onMenuAction()"
                            #tuesdaySummaryChipTrigger="matMenuTrigger">
                    <span>{{ getSummaryNoteText('tuesday') }}</span>
                  </mat-chip>
                }
              </div>
            </td>
          </ng-container>

          <!-- Szerda oszlop -->
          <ng-container matColumnDef="wednesday">
            <th mat-header-cell *matHeaderCellDef class="day-header"
                (mouseenter)="onColumnHover('wednesday')"
                (mouseleave)="onColumnLeave()">Szerda</th>
            <td mat-cell *matCellDef="let row; let rowIndex = index" 
                [class]="getCellClassWithColumnNote(row.wednesday, 4, 'wednesday')"
                [ngStyle]="getCellStyle(row, 'wednesday')"
                (mouseenter)="onColumnHover('wednesday')"
                (mouseleave)="onColumnLeave()">
              <div class="cell-content">
                @if (!isLastRow(row)) {
                  <span>{{ row.wednesday }}</span>
                }
                @if (!isSummaryTable && shouldShowNoteIcon(row, 'wednesday') && canEditSummaryNotes()) {
                  <mat-icon class="note-icon"
                            [matMenuTriggerFor]="wednesdayNoteMenu.menu"
                            (click)="setSelectedColumn('wednesday', wednesdayMenuTrigger)"
                            (menuOpened)="wednesdayNoteMenu.onMenuOpened()"
                            (menuClosed)="onMenuAction()"
                            #wednesdayMenuTrigger="matMenuTrigger">
                    edit_note
                  </mat-icon>
                }
                @if (!isSummaryTable && shouldShowNoteChip(row, 'wednesday')) {
                  <mat-chip [class]="'note-chip ' + getNoteChipClass('wednesday') + (canEditSummaryNotes() ? ' clickable-chip' : '')"
                            [matMenuTriggerFor]="canEditSummaryNotes() ? wednesdayNoteMenu.menu : null"
                            (click)="canEditSummaryNotes() ? setSelectedColumn('wednesday', wednesdayChipTrigger) : null"
                            (menuOpened)="wednesdayNoteMenu.onMenuOpened()"
                            (menuClosed)="onMenuAction()"
                            #wednesdayChipTrigger="matMenuTrigger">
                    <span>{{ getNoteText('wednesday') }}</span>
                  </mat-chip>
                }
                @if (isSummaryTable && shouldShowSummaryNoteIcon(row, 'wednesday')) {
                  <mat-icon class="note-icon"
                            [matMenuTriggerFor]="wednesdaySummaryNoteMenu.menu"
                            (click)="setSelectedColumn('wednesday', wednesdaySummaryMenuTrigger)"
                            (menuOpened)="wednesdaySummaryNoteMenu.onMenuOpened()"
                            (menuClosed)="onMenuAction()"
                            #wednesdaySummaryMenuTrigger="matMenuTrigger">
                    edit_note
                  </mat-icon>
                }
                @if (isSummaryTable && shouldShowSummaryNoteChip(row, 'wednesday')) {
                  <mat-chip [class]="'note-chip ' + getSummaryNoteChipClass('wednesday') + (canEditSummaryNotes() ? ' clickable-chip' : '')"
                            [matMenuTriggerFor]="canEditSummaryNotes() ? wednesdaySummaryNoteMenu.menu : null"
                            (click)="canEditSummaryNotes() ? setSelectedColumn('wednesday', wednesdaySummaryChipTrigger) : null"
                            (menuOpened)="wednesdaySummaryNoteMenu.onMenuOpened()"
                            (menuClosed)="onMenuAction()"
                            #wednesdaySummaryChipTrigger="matMenuTrigger">
                    <span>{{ getSummaryNoteText('wednesday') }}</span>
                  </mat-chip>
                }
              </div>
            </td>
          </ng-container>

          <!-- Csütörtök oszlop -->
          <ng-container matColumnDef="thursday">
            <th mat-header-cell *matHeaderCellDef class="day-header"
                (mouseenter)="onColumnHover('thursday')"
                (mouseleave)="onColumnLeave()">Csütörtök</th>
            <td mat-cell *matCellDef="let row; let rowIndex = index" 
                [class]="getCellClassWithColumnNote(row.thursday, 5, 'thursday')"
                [ngStyle]="getCellStyle(row, 'thursday')"
                (mouseenter)="onColumnHover('thursday')"
                (mouseleave)="onColumnLeave()">
              <div class="cell-content">
                @if (!isLastRow(row)) {
                  <span>{{ row.thursday }}</span>
                }
                @if (!isSummaryTable && shouldShowNoteIcon(row, 'thursday') && canEditSummaryNotes()) {
                  <mat-icon class="note-icon"
                            [matMenuTriggerFor]="thursdayNoteMenu.menu"
                            (click)="setSelectedColumn('thursday', thursdayMenuTrigger)"
                            (menuOpened)="thursdayNoteMenu.onMenuOpened()"
                            (menuClosed)="onMenuAction()"
                            #thursdayMenuTrigger="matMenuTrigger">
                    edit_note
                  </mat-icon>
                }
                @if (!isSummaryTable && shouldShowNoteChip(row, 'thursday')) {
                  <mat-chip [class]="'note-chip ' + getNoteChipClass('thursday') + (canEditSummaryNotes() ? ' clickable-chip' : '')"
                            [matMenuTriggerFor]="canEditSummaryNotes() ? thursdayNoteMenu.menu : null"
                            (click)="canEditSummaryNotes() ? setSelectedColumn('thursday', thursdayChipTrigger) : null"
                            (menuOpened)="thursdayNoteMenu.onMenuOpened()"
                            (menuClosed)="onMenuAction()"
                            #thursdayChipTrigger="matMenuTrigger">
                    <span>{{ getNoteText('thursday') }}</span>
                  </mat-chip>
                }
                @if (isSummaryTable && shouldShowSummaryNoteIcon(row, 'thursday')) {
                  <mat-icon class="note-icon"
                            [matMenuTriggerFor]="thursdaySummaryNoteMenu.menu"
                            (click)="setSelectedColumn('thursday', thursdaySummaryMenuTrigger)"
                            (menuOpened)="thursdaySummaryNoteMenu.onMenuOpened()"
                            (menuClosed)="onMenuAction()"
                            #thursdaySummaryMenuTrigger="matMenuTrigger">
                    edit_note
                  </mat-icon>
                }
                @if (isSummaryTable && shouldShowSummaryNoteChip(row, 'thursday')) {
                  <mat-chip [class]="'note-chip ' + getSummaryNoteChipClass('thursday') + (canEditSummaryNotes() ? ' clickable-chip' : '')"
                            [matMenuTriggerFor]="canEditSummaryNotes() ? thursdaySummaryNoteMenu.menu : null"
                            (click)="canEditSummaryNotes() ? setSelectedColumn('thursday', thursdaySummaryChipTrigger) : null"
                            (menuOpened)="thursdaySummaryNoteMenu.onMenuOpened()"
                            (menuClosed)="onMenuAction()"
                            #thursdaySummaryChipTrigger="matMenuTrigger">
                    <span>{{ getSummaryNoteText('thursday') }}</span>
                  </mat-chip>
                }
              </div>
            </td>
          </ng-container>

          <!-- Péntek oszlop -->
          <ng-container matColumnDef="friday">
            <th mat-header-cell *matHeaderCellDef class="day-header"
                (mouseenter)="onColumnHover('friday')"
                (mouseleave)="onColumnLeave()">Péntek</th>
            <td mat-cell *matCellDef="let row; let rowIndex = index" 
                [class]="getCellClassWithColumnNote(row.friday, 6, 'friday')"
                [ngStyle]="getCellStyle(row, 'friday')"
                (mouseenter)="onColumnHover('friday')"
                (mouseleave)="onColumnLeave()">
              <div class="cell-content">
                @if (!isLastRow(row)) {
                  <span>{{ row.friday }}</span>
                }
                @if (!isSummaryTable && shouldShowNoteIcon(row, 'friday') && canEditSummaryNotes()) {
                  <mat-icon class="note-icon"
                            [matMenuTriggerFor]="fridayNoteMenu.menu"
                            (click)="setSelectedColumn('friday', fridayMenuTrigger)"
                            (menuOpened)="fridayNoteMenu.onMenuOpened()"
                            (menuClosed)="onMenuAction()"
                            #fridayMenuTrigger="matMenuTrigger">
                    edit_note
                  </mat-icon>
                }
                @if (!isSummaryTable && shouldShowNoteChip(row, 'friday')) {
                  <mat-chip [class]="'note-chip ' + getNoteChipClass('friday') + (canEditSummaryNotes() ? ' clickable-chip' : '')"
                            [matMenuTriggerFor]="canEditSummaryNotes() ? fridayNoteMenu.menu : null"
                            (click)="canEditSummaryNotes() ? setSelectedColumn('friday', fridayChipTrigger) : null"
                            (menuOpened)="fridayNoteMenu.onMenuOpened()"
                            (menuClosed)="onMenuAction()"
                            #fridayChipTrigger="matMenuTrigger">
                    <span>{{ getNoteText('friday') }}</span>
                  </mat-chip>
                }
                @if (isSummaryTable && shouldShowSummaryNoteIcon(row, 'friday')) {
                  <mat-icon class="note-icon"
                            [matMenuTriggerFor]="fridaySummaryNoteMenu.menu"
                            (click)="setSelectedColumn('friday', fridaySummaryMenuTrigger)"
                            (menuOpened)="fridaySummaryNoteMenu.onMenuOpened()"
                            (menuClosed)="onMenuAction()"
                            #fridaySummaryMenuTrigger="matMenuTrigger">
                    edit_note
                  </mat-icon>
                }
                @if (isSummaryTable && shouldShowSummaryNoteChip(row, 'friday')) {
                  <mat-chip [class]="'note-chip ' + getSummaryNoteChipClass('friday') + (canEditSummaryNotes() ? ' clickable-chip' : '')"
                            [matMenuTriggerFor]="canEditSummaryNotes() ? fridaySummaryNoteMenu.menu : null"
                            (click)="canEditSummaryNotes() ? setSelectedColumn('friday', fridaySummaryChipTrigger) : null"
                            (menuOpened)="fridaySummaryNoteMenu.onMenuOpened()"
                            (menuClosed)="onMenuAction()"
                            #fridaySummaryChipTrigger="matMenuTrigger">
                    <span>{{ getSummaryNoteText('friday') }}</span>
                  </mat-chip>
                }
              </div>
            </td>
          </ng-container>

          <!-- Összesen oszlop -->
          <ng-container matColumnDef="total">
            <th mat-header-cell *matHeaderCellDef class="total-header"
                (mouseenter)="onColumnHover('total')"
                (mouseleave)="onColumnLeave()">Összesen</th>
            <td mat-cell *matCellDef="let row" 
                class="total-cell"
                [style.background-color]="row.backgroundColor"
                (mouseenter)="onColumnHover('total')"
                (mouseleave)="onColumnLeave()">
              <div class="cell-content">
                @if (!isLastRow(row)) {
                  <strong>{{ row.total }}</strong>
                }
              </div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
      </div>
    </mat-card-content>
  </mat-card>
</div>

<!-- Napi jegyzet menük -->
<app-small-input-menu
  inputType="notes"
  [notePresets]="[{value:'SZ', label:'SZ - szabadág'}, {value:'TR', label:'TR - tréning'}, {value:'B', label:'B - beteg'}]"
  label="Hétfő jegyzet"
  placeholder="Írj egy jegyzetet..."
  [inputValue]="notes['monday']"
  [showDeleteButton]="true"
  [menuTrigger]="currentMenuTrigger"
  (valueAdded)="onNoteAdded($event, 'monday')"
  (cancelled)="onNoteCancelled()"
  (deleteClicked)="onNoteDeleted('monday')"
  #mondayNoteMenu>
</app-small-input-menu>

<app-small-input-menu
  inputType="notes"
  [notePresets]="[{value:'SZ', label:'SZ - szabadág'}, {value:'TR', label:'TR - tréning'}, {value:'B', label:'B - beteg'}]"
  label="Kedd jegyzet"
  placeholder="Írj egy jegyzetet..."
  [inputValue]="notes['tuesday']"
  [showDeleteButton]="true"
  [menuTrigger]="currentMenuTrigger"
  (valueAdded)="onNoteAdded($event, 'tuesday')"
  (cancelled)="onNoteCancelled()"
  (deleteClicked)="onNoteDeleted('tuesday')"
  #tuesdayNoteMenu>
</app-small-input-menu>

<app-small-input-menu
  inputType="notes"
  [notePresets]="[{value:'SZ', label:'SZ - szabadág'}, {value:'TR', label:'TR - tréning'}, {value:'B', label:'B - beteg'}]"
  label="Szerda jegyzet"
  placeholder="Írj egy jegyzetet..."
  [inputValue]="notes['wednesday']"
  [showDeleteButton]="true"
  [menuTrigger]="currentMenuTrigger"
  (valueAdded)="onNoteAdded($event, 'wednesday')"
  (cancelled)="onNoteCancelled()"
  (deleteClicked)="onNoteDeleted('wednesday')"
  #wednesdayNoteMenu>
</app-small-input-menu>

<app-small-input-menu
  inputType="notes"
  [notePresets]="[{value:'SZ', label:'SZ - szabadág'}, {value:'TR', label:'TR - tréning'}, {value:'B', label:'B - beteg'}]"
  label="Csütörtök jegyzet"
  placeholder="Írj egy jegyzetet..."
  [inputValue]="notes['thursday']"
  [showDeleteButton]="true"
  [menuTrigger]="currentMenuTrigger"
  (valueAdded)="onNoteAdded($event, 'thursday')"
  (cancelled)="onNoteCancelled()"
  (deleteClicked)="onNoteDeleted('thursday')"
  #thursdayNoteMenu>
</app-small-input-menu>

<app-small-input-menu
  inputType="notes"
  [notePresets]="[{value:'SZ', label:'SZ - szabadág'}, {value:'TR', label:'TR - tréning'}, {value:'B', label:'B - beteg'}]"
  label="Péntek jegyzet"
  placeholder="Írj egy jegyzetet..."
  [inputValue]="notes['friday']"
  [showDeleteButton]="true"
  [menuTrigger]="currentMenuTrigger"
  (valueAdded)="onNoteAdded($event, 'friday')"
  (cancelled)="onNoteCancelled()"
  (deleteClicked)="onNoteDeleted('friday')"
  #fridayNoteMenu>
</app-small-input-menu>

<!-- Összesítő táblázat napi note menük (summary_notes táblából) -->
<app-small-input-menu
  inputType="notes"  [notePresets]="[{value:'SZ', label:'SZ - szabadág'}, {value:'TR', label:'TR - tréning'}, {value:'B', label:'B - beteg'}]"  label="Összesítő - Hétfő"
  placeholder="Írj egy összesítő jegyzetet..."
  [inputValue]="summaryNotes['monday']"
  [showDeleteButton]="true"
  [menuTrigger]="currentMenuTrigger"
  (valueAdded)="onSummaryNoteAdded($event, 'monday')"
  (cancelled)="onNoteCancelled()"
  (deleteClicked)="onSummaryNoteDeleted('monday')"
  #mondaySummaryNoteMenu>
</app-small-input-menu>

<app-small-input-menu
  inputType="notes"  [notePresets]="[{value:'SZ', label:'SZ - szabadág'}, {value:'TR', label:'TR - tréning'}, {value:'B', label:'B - beteg'}]"  label="Összesítő - Kedd"
  placeholder="Írj egy összesítő jegyzetet..."
  [inputValue]="summaryNotes['tuesday']"
  [showDeleteButton]="true"
  [menuTrigger]="currentMenuTrigger"
  (valueAdded)="onSummaryNoteAdded($event, 'tuesday')"
  (cancelled)="onNoteCancelled()"
  (deleteClicked)="onSummaryNoteDeleted('tuesday')"
  #tuesdaySummaryNoteMenu>
</app-small-input-menu>

<app-small-input-menu
  inputType="notes"  [notePresets]="[{value:'SZ', label:'SZ - szabadág'}, {value:'TR', label:'TR - tréning'}, {value:'B', label:'B - beteg'}]"  label="Összesítő - Szerda"
  placeholder="Írj egy összesítő jegyzetet..."
  [inputValue]="summaryNotes['wednesday']"
  [showDeleteButton]="true"
  [menuTrigger]="currentMenuTrigger"
  (valueAdded)="onSummaryNoteAdded($event, 'wednesday')"
  (cancelled)="onNoteCancelled()"
  (deleteClicked)="onSummaryNoteDeleted('wednesday')"
  #wednesdaySummaryNoteMenu>
</app-small-input-menu>

<app-small-input-menu
  inputType="notes"  [notePresets]="[{value:'SZ', label:'SZ - szabadág'}, {value:'TR', label:'TR - tréning'}, {value:'B', label:'B - beteg'}]"  label="Összesítő - Csütörtök"
  placeholder="Írj egy összesítő jegyzetet..."
  [inputValue]="summaryNotes['thursday']"
  [showDeleteButton]="true"
  [menuTrigger]="currentMenuTrigger"
  (valueAdded)="onSummaryNoteAdded($event, 'thursday')"
  (cancelled)="onNoteCancelled()"
  (deleteClicked)="onSummaryNoteDeleted('thursday')"
  #thursdaySummaryNoteMenu>
</app-small-input-menu>

<app-small-input-menu
  inputType="notes"  [notePresets]="[{value:'SZ', label:'SZ - szabadág'}, {value:'TR', label:'TR - tréning'}, {value:'B', label:'B - beteg'}]"  label="Összesítő - Péntek"
  placeholder="Írj egy összesítő jegyzetet..."
  [inputValue]="summaryNotes['friday']"
  [showDeleteButton]="true"
  [menuTrigger]="currentMenuTrigger"
  (valueAdded)="onSummaryNoteAdded($event, 'friday')"
  (cancelled)="onNoteCancelled()"
  (deleteClicked)="onSummaryNoteDeleted('friday')"
  #fridaySummaryNoteMenu>
</app-small-input-menu>
